import { useLocale } from "next-intl";
import {
  queryOptions,
  usePrefetchQuery,
  useQuery,
} from "@tanstack/react-query";

import { getSportsNew, GetSportsNewParams } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "./sportsNewQueryKeys";

export const createSportsNewQueryOptions = (params: GetSportsNewParams) => {
  return queryOptions({
    queryKey: [SportsNewQueryKeys.SportsNew, params],
    queryFn: ({ signal }) => getSportsNew({ params, signal }),
  });
};

export const useSportsNew = (params: GetSportsNewParams = {}) => {
  const lang = useLocale();
  const fullParams = { lang, ...params };

  return useQuery(createSportsNewQueryOptions(fullParams));
};

export const usePrefetchSportsNew = (params: GetSportsNewParams = {}) => {
  const lang = useLocale();
  const fullParams = { lang, ...params };

  return usePrefetchQuery(createSportsNewQueryOptions(fullParams));
};

export const usePopularSports = () => {
  return useSportsNew({ popular: true, active: true });
};

export const useMostPopularSports = () => {
  return useSportsNew({ mostPopular: true, active: true });
};

export const usePrefetchMostPopularSports = () => {
  return usePrefetchSportsNew({ mostPopular: true, active: true });
};
